var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectInvertion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7926 5.04012C16.4225 4.41015 17.4997 4.85632 17.4997 5.74722V16.4997C17.4997 17.052 17.052 17.4997 16.4997 17.4997H5.74722C4.85632 17.4997 4.41015 16.4225 5.04011 15.7926L15.7926 5.04012Z",
    fill: "#7F869A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H2.5V15.8333",
    stroke: "#7F869A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectInvertion);
export default __webpack_public_path__ + "static/media/selectInvertion.f21e6d6f87d06ce399338c9aba620aa4.svg";
export { ForwardRef as ReactComponent };